import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-brand-light px-4 py-6 sm:px-6" aria-labelledby="faq-heading" data-id="element-34" data-mp="1hcrxiameb0tt">
      <h2 id="faq-heading" className="mb-3 text-center text-2xl leading-none text-brand-ink sm:text-4xl" data-id="element-35" data-mp="1cf041c63r6ni">
        FREQUENTLY ASKED QUESTIONS
      </h2>
      <div className="mx-auto max-w-xl space-y-1.5" data-id="element-36" data-mp="2a1gz0ard5863">
        {faqs.map((faq, index) => <article key={faq.question} className="overflow-hidden rounded-xl bg-white shadow-sm" data-id="element-37" data-mp="253xbek8rzj1h" data-mpi={index}>
            <button type="button" aria-expanded={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between gap-2 px-3 py-2.5 text-left hover:bg-brand-red/5 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-brand-red" data-id="element-38" data-mp="202hsaxq5rmlq">
              <span className="font-heading text-[11px] font-semibold leading-snug text-brand-ink sm:text-xs" data-id="element-39" data-mp="1korrtgyfbuhi">
                {faq.question}
              </span>
              <ChevronDownIcon className={`h-4 w-4 shrink-0 text-brand-red transition-transform ${openIndex === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-40" data-mp="1apsv8wqxnpav" />
            </button>
            {openIndex === index && <p className="px-3 pb-2.5 text-[11px] leading-snug text-brand-muted sm:text-xs" data-id="element-41" data-mp="11v5tcakh9v3d">
                {faq.answer}
              </p>}
          </article>)}
      </div>
    </section>;
}